import { getToken } from "./user-service";
import axios from "axios";

/**
 * Get passenger list for a specific flight - bypasses zone and date range filters
 * This is used when viewing a flight directly (e.g., from flight search)
 * where the bookings may not be in the current timeline cache
 * 
 * @param {Object} params - Query parameters
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.flightNumber - Full flight number (e.g., "EI101")
 * @param {string} params.departureDate - Departure date in YYYY-MM-DD format
 * @param {string} params.type - Flight type ("inbound" or "outbound")
 * @returns {Promise<Array>} Array of booking/passenger documents for the flight
 */
export const getFlightPassengerList = async (params) => {
    const token = await getToken();

    // Build query string
    const queryParams = new URLSearchParams({
        flightNumber: params.flightNumber,
        departureDate: params.departureDate,
        type: params.type,
    });

    const url = `/api/v1/bookings/timeline/flightPassengerList?iata=${params.iata}&${queryParams.toString()}`;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(url, {
                headers: { "Firebase-UID": token },
            });

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Issue getting flight passenger list");
            }

            resolve(response.data);
        } catch (e) {
            reject(new Error(e.response?.data?.message || "Error getting flight passenger list"));
        }
    });
};
